import FqApi from '@/services/fq-api'
// import ProtoBuf from 'protobufjs'
// import ProtoBufApi from '@/services/protobuf-api'

export default {

  ////////////////////////////////////// Quote Header ///////////////////////////////////////
  // get quote header by quoteId
  async getQuoteHeader(quoteId) {
    const url = `/quotes/getQuoteHeader/${quoteId}`
    const result = await FqApi.get(url)
    return result.data
  },
  // save quote header
  async saveQuoteHeader(quoteId, quoteHeaderObj) {
    const url = `/quotes/saveQuoteHeader/${quoteId}`
    const result = await FqApi.put(url, quoteHeaderObj)
    return result.data
  },
  // save rates and markups only
  async saveRatesMarkups(quoteId, ratesMarkupsObj) {
    const url = `/quotes/saveRatesMarkups/${quoteId}`
    const result = await FqApi.put(url, ratesMarkupsObj)
    return result.data
  },
  ////////////////////////////////////// Quote Items ///////////////////////////////////////
    // Bulk-save the full managed item set in a single PUT (add/update/soft-delete).
    async saveQuoteItems(quoteId, quoteItemObjArr) {
      const url = `/quotes/${quoteId}/quote-items`
      const result = await FqApi.put(url, quoteItemObjArr)
      return result.data
    },
  ////////////////////////////////////// Discrete Field Saves ///////////////////////////////////////
  async saveJobStage(quoteId, payload) {
    const result = await FqApi.put(`/quotes/saveJobStage/${quoteId}`, payload)
    return result.data
  },
  async saveReadOnly(quoteId, payload) {
    const result = await FqApi.put(`/quotes/saveReadOnly/${quoteId}`, payload)
    return result.data
  },
  async saveAssessmentEnabled(quoteId, payload) {
    const result = await FqApi.put(`/quotes/saveAssessmentEnabled/${quoteId}`, payload)
    return result.data
  }
  }